import Icon from '../components/Icon.vue'

Icon.register({
  'hand-point-left': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M44.8 155.8h149.2c-5.8-8.2-10.6-16.6-14.2-24.9-13.6-31.8 9.9-66.9 44.1-66.9 18.6 0 32.2 10.9 40 29.1 12.1 28.3 78.6 64.3 107.5 77.3 17.9 8 28.5 25.5 28.5 43.8l0 0v171.5c0 11.8-8.6 21.9-20.3 23.7-46.8 7.3-61.8 38.5-123.7 38.3-2.7 0-13.3 0.2-16 0.2-50.7 0-81.6-22.1-72.6-71.3-18.6-9.3-30.7-39.5-16.5-62.3-24.6-21.2-22.6-53.9-6.3-70.9h-99.9c-24.1 0-44.8-20.2-44.8-43.8 0-23.3 21.3-43.8 44.8-43.8zM440 176h48c13.3 0 24 10.7 24 24v192c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-192c0-13.3 10.7-24 24-24zM464 388c11 0 20-9 20-20s-9-20-20-20-20 9-20 20 9 20 20 20z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-point-left.js
// module id = 1432
// module chunks = 0